/*
 * Rejilla de obra del portfolio.
 *
 * La rejilla en si no necesita JavaScript: es grid puro con el `span` de
 * cada celda calculado en Liquid. Esto solo conecta los botones de la
 * rejilla con el visor compartido (`assets/reda-visor.js`).
 *
 * Un custom element por galeria: todo lo que busca lo busca dentro de si
 * mismo, asi que dos galerias en la misma pagina no se pisan.
 */

if (!customElements.get('reda-galeria')) {
  customElements.define(
    'reda-galeria',
    class RedaGaleria extends HTMLElement {
      constructor() {
        super();

        this.obras = Array.from(this.querySelectorAll('[data-reda-obra]'));
        this.dialogo = this.querySelector('[data-reda-visor]');
        this.visor = null;
      }

      connectedCallback() {
        if (!this.dialogo || this.obras.length === 0) return;

        this.obras.forEach((obra, i) => {
          obra.addEventListener('click', () => this.abrir(i));
        });
      }

      // El visor se construye al primer uso: asi da igual en que orden
      // carguen reda-visor.js y este archivo.
      obtenerVisor() {
        if (!this.visor && window.RedaVisor) {
          this.visor = new window.RedaVisor(this.dialogo);
        }
        return this.visor;
      }

      abrir(indice) {
        const visor = this.obtenerVisor();
        if (!visor) return;

        visor.abrir(window.redaFuentesDe(this.obras), indice, {
          // El foco vuelve a la obra que se estaba viendo, que si no se ha
          // navegado es la misma desde la que se abrio.
          alCerrar: (i) => {
            const obra = this.obras[i] || this.obras[indice];
            if (obra) obra.focus();
          },
        });
      }
    }
  );
}
